import { render, staticRenderFns } from "./PaymentLabel.vue?vue&type=template&id=c9dc2568"
import script from "./PaymentLabel.vue?vue&type=script&lang=ts"
export * from "./PaymentLabel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports